import 'focus-visible';
import 'tippy.js/dist/tippy.css';

import { createApp } from '../ssrApp.js';
import notifications from "@store/modules/notifications";
import emailCapture from "@store/modules/emailCapture";
import signIn from "@store/modules/signIn";

async function init() {
  const { app, store, router } = await createApp({
    html: window.__SSR_APP_HTML__,
    computedContentClasses: window.__SSR_COMPUTED_CONTENT_CLASSES__,
    cmsContentId: window.__SSR_CMS_CONTENT_ID__,
  });

  if (window.__INITIAL_STATE__) {
    store.replaceState(window.__INITIAL_STATE__);
  }

  app.provide('$ssrContext', {});

  // Client only stores
  store.registerModule('notifications', notifications);
  store.registerModule('emailCapture', emailCapture);
  store.registerModule('signIn', signIn);

// Use the original CMS code as Vue template for the "SsrApp.vue" "created" life-cycle hook.
  store.commit('global/setAppHtml', window.__SSR_APP_HTML__);

  await router.replace(window.location.pathname);

  await router.isReady();

  app.mount('#mrVueApp');
}

init();
